var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center h-100"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.$masterRoute + '/image/logo_pintucity_270px.png',"alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }